module.exports = __webpack_public_path__ + "img/dental4_7-8-2021.9b59dc57.jpg";